export const FigurePayStates = [
  { abbr: 'AK', name: 'Alaska' },
  { abbr: 'AZ', name: 'Arizona' },
  { abbr: 'CO', name: 'Colorado' },
  { abbr: 'CT', name: 'Connecticut' },
  { abbr: 'DE', name: 'Delaware' },
  { abbr: 'IL', name: 'Illinois' },
  { abbr: 'IA', name: 'Iowa' },
  { abbr: 'KS', name: 'Kansas' },
  { abbr: 'KY', name: 'Kentucky' },
  { abbr: 'ME', name: 'Maine' },
  { abbr: 'MD', name: 'Maryland' },
  { abbr: 'MO', name: 'Missouri' },
  { abbr: 'MT', name: 'Montana' },
  { abbr: 'NV', name: 'Nevada' },
  { abbr: 'NH', name: 'New Hampshire' },
  { abbr: 'NJ', name: 'New Jersey' },
  { abbr: 'NM', name: 'New Mexico' },
  { abbr: 'OR', name: 'Oregon' },
  { abbr: 'SD', name: 'South Dakota' },
  { abbr: 'UT', name: 'Utah' },
  { abbr: 'WY', name: 'Wyoming' },
];
export const FPayExcludeReasons = [
  'FRAUD',
  'OFAC',
  'F_DELQ_CURRENT',
  'F_DELQ_MAX',
  'F_TRANSFERRED',
  'F_FORECLOSURE',
  'F_BANKRUPTCY',
  'DNDB_BLACKLIST',
];

//NOTE: FRAUD and OFAC decline reasons will not see Figure Pay decline screen but will see Even Financial Decline (FIONA) screen
export const FionaExcludeReasons = [
  'CREDITINCOMPLETE',
  'INCOME_VERIFICATION',
  'ID_VERIFICATION',
  'F_DELQ_CURRENT',
  'F_DELQ_MAX',
  'F_TRANSFERRED',
  'F_FORECLOSURE',
  'F_BANKRUPTCY',
  'DNDB_BLACKLIST',
];

export const FIGUREPAY_APPLESTORE = 'https://apps.apple.com/us/app/figure-pay/id1529369990';
export const FIGUREPAY_PLAYSTORE =
  'https://play.google.com/store/apps/details?id=com.figure.mobile.figurepay';
